import { TaskStatus } from '@/legacy/types';
import { TrackedTask } from '@/legacy/types/taskTypes';

export type TaskTrackerSlice = {
	tasks: Record<string, TrackedTask>;
	setTask: (
		taskId: string,
		metadata?: {
			label: string;
			successNotificationMessage: string;
			errorNotificationMessage: string;
			url?: string;
		},
	) => void;
	setTaskStatus: (taskId: string, status: TaskStatus) => void;
	clearTask: (taskId: string) => void;
	resetTaskTrackerSlice: () => void;
};

type SetFunction = (
	partial: Partial<TaskTrackerSlice> | ((state: TaskTrackerSlice) => Partial<TaskTrackerSlice>),
) => void;

export const createTaskTrackerSlice = (set: SetFunction): TaskTrackerSlice => ({
	tasks: {},

	setTask: (taskId, metadata) =>
		set((state: TaskTrackerSlice) => ({
			tasks: {
				...state.tasks,
				[taskId]: { taskId, status: 'processing', ...metadata },
			},
		})),

	setTaskStatus: (taskId, status) =>
		set((state: TaskTrackerSlice) => {
			const task = state.tasks[taskId];
			if (!task) return state;
			return {
				tasks: {
					...state.tasks,
					[taskId]: { ...task, status },
				},
			};
		}),

	clearTask: (taskId) =>
		set((state: TaskTrackerSlice) => {
			const newTasks = { ...state.tasks };
			delete newTasks[taskId];
			return { tasks: newTasks };
		}),

	resetTaskTrackerSlice: () =>
		set(() => ({
			tasks: {},
		})),
});
